import { Line } from 'vue-chartjs'
import map from 'lodash/map'
import unique from 'lodash/uniq'
import flattenDeep from 'lodash/flattenDeep'
import ChartDataLabels from 'chartjs-plugin-datalabels';
import chartjsPluginAnnotation from "chartjs-plugin-annotation";
import maxBy from 'lodash/maxBy';
import forEach from 'lodash/forEach';
import toInteger from 'lodash/toInteger';
import lang from '../../../lang/translator';
import split from "lodash/split";


export default {
  name: 'LineChart',
  extends: Line,
  props: {
    datasets: {
      required: true,
      type: [Array, Object],
    },
    showLegend: {
      required: false,
      type: [Boolean],
      default: true,
    },
    yAxesBeginAtZero: {
      required: false,
      type: [Boolean],
      default: false,
    },
    animationDuration: {
      required: false,
      type: [Number],
      default: 0,
    },
    scaleLabel: {
      required: false,
      type: [Array, Object, String],
      default: function() {
        return {
          display: false,
        };
      },
    },
    verticalLinePoint: {
      required: false,
      type: [Array, Object],
      default: null
    },
    yLabels: {
      required: true,
      type: [Array, Object],
    },
    listChartDate: {
      required: false,
      type: [Array, Object],
      default: null,
    },
    aspectRatio: {
      required: false,
      type: [Boolean],
      default: true,
    },
    stageInfo: null,
    allAxisShow: {
      required: false,
      type: [Boolean],
      default: false,
    },
    xAxisLabel: {
      required: false,
      type: [String],
      default: lang.get('report.day_session'),
    },


  },
  mounted() {
    this.render();
  },
  plugins: [ChartDataLabels, chartjsPluginAnnotation],
  methods: {
    render() {
      let lastHoveredIndex = 0;
      let xLabels = [];
      if (this.listChartDate){
        xLabels =  this.listChartDate;
      } else{
        xLabels =  unique(flattenDeep(map(this.datasets,
          dataset => map(dataset.data, (item) => item.x))));
      }

      let dataset = [];
      let allAxisShow = this.allAxisShow;

      let pointArray = [];


      forEach (this.verticalLinePoint, (point,index) =>{

        pointArray.push({
          id: "vertLine"+index,
          type: "line",
          mode: "vertical",
          scaleID: "x-axis-0",
          value: point.x,
          borderColor: "black",
          borderDash: point.isImportant ?  0 : [5, 5],
          borderWidth: 2,
          onMouseover: function(e) {
            let element = this;
            //element.options.label.content = '';
            let tooltipEl = document.getElementById('chartjs-tooltip-vertical');

            if (!tooltipEl) {
              tooltipEl = document.createElement('div');
              tooltipEl.id = 'chartjs-tooltip-vertical';
              element.chartInstance.canvas.parentNode.appendChild(tooltipEl);
            }

            tooltipEl.innerHTML = '<div>'+point.comment+'</div>';
            element.chartInstance.update();
          },
          onMouseout: function(e) {
            let element = this;
            element.options.label.content = point.comment.substr(0,5);
            let tooltipEl = document.getElementById('chartjs-tooltip-vertical');
            if (tooltipEl) {
              tooltipEl.parentNode.removeChild(tooltipEl);
            }
            element.chartInstance.update();
          },
          label: {
            content: point.comment.substr(0,5),
            enabled: true,
            position: "top",
            xPadding: 16,
            yPadding: 10,
            yAdjust: index % 3 === 1 ? 10 : index % 3 === 2 ? 50 : 80,
            xAdjust: index === 0 ? -40 : 0
          }
        })
      });

      let chart = this;

      let colorY = [];

      forEach(this.yLabels, item => {
        let value = split(item, '_');
        if(!value[1]){
          colorY.push('rgba(0,0,0,0.1)')
        } else{
          colorY.push('rgba(0,0,0,0)')
        }
      });

      let colorX = [];

      forEach(xLabels, item => {
        let value = split(item, '_');
        if(!value[1]){
          colorX.push('rgba(0,0,0,0.1)')
        } else{
          colorX.push('rgba(0,0,0,0)')
        }
      });


      this.renderChart(
          {
            xLabels: xLabels,
            yLabels: this.yLabels,
            datasets: this.datasets,
          },
          {
            animation: {
              duration: this.animationDuration
            },
            tooltips: {
              enabled: false
            },
            layout: {
              padding: {
                left: 30,
                right: 40,
                top: 0,
                bottom: 0
              }
            },
            'onClick': function(evt, item) {
              if (item[0]) {

                const activePoints = this.getElementAtEvent(evt);
                let point = this.data.datasets[activePoints[0]._datasetIndex].data[activePoints[0]._index];
                chart.$emit('popup-show', point, chart.stageInfo);
              }

            },
            responsive: true,
            maintainAspectRatio: this.aspectRatio,
            aspectRatio: this.aspectRatio ? 1.6 : false,
            showAllTooltips: false,
            annotation: {
              events: ['dblclick', 'mouseover', 'mouseout'],
              annotations: pointArray,
            },
            legend: {
              display: this.showLegend,
              position: 'bottom',
            },
            scales: {
              yAxes: [{
                type: 'category',
                position: 'left',
                display: true,
                afterTickToLabelConversion: function(scaleInstance) {
                  /*forEach(scaleInstance.ticks, (tick, index) => {
                    if (index % 4 !== 0){
                      scaleInstance.ticks[index] = '';
                    }
                  });*/

                },
                gridLines:{
                  color: colorY
                },
                ticks: {
                  stepSize: 4,
                  autoSkip: false,
                  callback: function (dataLabel, index) {
                    let value = split(dataLabel, '_')
                    // Hide the text after _

                    return (index + 2) % 4 === 0 ? value[0] + ' П' : '';
                  }
                },
                scaleLabel: {
                  display: true,
                  labelString: lang.get('protocol.mastering_criteria')
                },
              }],
              xAxes: [{
                  scaleLabel: {
                    display: true,
                    labelString: this.xAxisLabel
                  },
                  gridLines:{
                    color: colorX
                  },

                  afterTickToLabelConversion: function(scaleInstance) {
                    if(!allAxisShow){

                      /*forEach(xLabels, (tick, index) => {
                        let value = split(tick, '_');

                        if (value.length > 1){
                          scaleInstance.ticks[index] = null;
                        }
                      });*/
                    }

                  },
                  ticks: {
                    display: true,
                    autoSkip: false,
                    maxRotation: 0,
                    minRotation: 0,
                    callback: function (dataLabel, index) {

                      let value = split(dataLabel, '_')
                      // Hide the text after _
                      return value[1] !== '3' && !allAxisShow ? '' : value[0];
                    }
                  }
                }
              ],
            },
            plugins: {
              datalabels: {
                backgroundColor: function(context) {
                  return context.dataset.backgroundColor;
                },
                borderRadius: 4,
                color: 'white',
                align: 'end',
                offset: 8,
                display: false, /*function(context) {
                  let index = context.dataIndex;
                  let value = context.dataset.data[index];
                  return value.y > 0;
                },*/
                formatter: function(value, context) {
                  return value.x + ": " + value.y;
                }
              }
            },
          },

      )
    },
  },
  watch: {
    datasets() {
      this.render();
    }
  },

}



// WEBPACK FOOTER //
// ./src/common/chart/Component/LineShapingChart.js